export const doctorFullnameTitleTrad = <
  U extends { firstname: string; lastname: string },
>(
  data: U,
) => {
  let firstname: string = '';
  if (data.firstname) {
    firstname = `${data.firstname[0]!.toUpperCase()}.`;
  }

  return {
    key: 'doctor.fullname-with-title',
    params: {
      firstname,
      lastname: data.lastname,
    },
  };
};
export type DoctorFullnameTitleTrad = ReturnType<
  typeof doctorFullnameTitleTrad
>;

export const doctorFullnameTrad = <
  U extends { firstname: string; lastname: string },
>(
  data: U,
) => {
  let firstname: string = '';
  if (data.firstname) {
    firstname = `${data.firstname[0]!.toUpperCase()}.`;
  }

  return {
    key: 'doctor.fullname-without-title',
    params: {
      firstname,
      lastname: data.lastname,
    },
  };
};

export const readableIban = (iban: string) => {
  return iban
    .replace(/\s+/g, '')
    .replace(/([a-z0-9]{4})/gi, '$1 ')
    .trim()
    .toLocaleUpperCase();
};
